import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";

import { useResendSignUp } from "@auth";
import { ConfirmPageTemplateProps } from "./template";

interface EmailState {
  email: string;
}

export const useConfirmPage = (): ConfirmPageTemplateProps => {
  const { state } = useLocation();
  const { email } = state as EmailState;
  const navigate = useNavigate();
  const resendSignUp = useResendSignUp();

  const handleBackButtonClick = () => navigate("/signin");
  const handleResendEmailClick = async () => {
    try {
      await resendSignUp(email);
      toast.success("Confirmation email sent successfully!", {
        description: "Please check your inbox for the new confirmation email.",
        duration: 5000,
      });
    } catch (error) {
      toast.error("Failed to send confirmation email", {
        description: "Please try again later or contact support if the issue persists.",
        duration: 5000,
      });
    }
  };

  return {
    handleBackButtonClick,
    handleResendEmailClick,
  };
};
